import styled from "styled-components";
import {
  spacing,
  color,
  borderRadius,
  elevation,
  palette,
} from "@conserveit/blocks";

function openClose({ isOpen }) {
  return isOpen ? "block" : "none";
}
export const Wrapper = styled.div`
  display: ${openClose};
  position: absolute;
  left: 100%;
  border-radius: ${borderRadius.default};
  border: 1px solid ${color.theme.divider.solid};
  height: 380px;
  width: 240px;
  padding-bottom: 40px;
  z-index: 10;
  background: ${color.pureWhite};
  box-shadow: ${elevation.modal};
  transform: translate(16px, -50%);
  cursor: default;
  white-space: normal;

  &:before {
    display: inline-block;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: 0;
    top: calc(50% - 6px);
    box-sizing: border-box;
    border: 12px solid black;
    border-color: transparent transparent ${color.pureWhite} ${color.pureWhite};
    transform-origin: 0 0;
    transform: rotate(45deg);
    box-shadow: ${elevation.modal};
    z-index: 0;
  }
`;

export const Inner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${color.pureWhite};
`;

export const Content = styled.div`
  position: relative;
  padding: 12px 0;
  height: 340px;
  overflow-y: scroll;
  background: ${color.pureWhite};
  z-index: 1;
`;

export const Row = styled.div`
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;

  h3 {
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  strong {
    font-weight: 600;
  }
`;

export const Summary = styled.p`
  margin: 0;
  padding: ${spacing.default};
  font-size: 14px;
  line-height: 20px;
  color: ${color.theme.typography.ink};
`;

export const Targets = styled.div`
  ul {
    padding: ${spacing.extraTight} ${spacing.default};
  }

  li {
    padding: ${spacing.extraTight} 0;
  }
`;

export const Description = styled.div`
  font-size: 13px;
  font-weight: 400;
  h4 {
    margin: 0;
    padding: 0 ${spacing.default} ${spacing.tight};
    font-size: 12px;
    font-weight: 600;
    border-bottom: 1px solid ${palette.neutral4};
  }

  p {
    margin: 0 0 ${spacing.extraTight};
    padding: 0 ${spacing.default};
  }
`;

export const SectionHeading = styled.h4`
  margin: 0;
  padding: 0 ${spacing.default} ${spacing.tight};
  font-size: 12px;
  font-weight: 600;
  border-bottom: 1px solid ${palette.neutral4};
`;

export const QuickLink = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  border-top: 1px solid ${palette.neutral4};
  padding: 0 16px;
  background: ${color.pureWhite};
  z-index: 1;

  a {
    font-size: 13px;
    line-height: 38px;
    color: ${color.theme.primaryColor.action.primary};
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
`;
